/**
 * DescriptionInfoContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

interface DescriptionInfoContainerProps {
  reducedSize?: boolean;
}

/**
 * Styled description info container.
 */
const DescriptionInfoContainer = styled.div<DescriptionInfoContainerProps>`
  display: flex;
  flex-direction: column;
  margin-bottom: ${14 * Screen.widthRatio}px;
  width: ${(props) => (props.reducedSize ? 740 : 986) * Screen.widthRatio}px;
`;

export default DescriptionInfoContainer;
